
const PAGE_AFTER_LOGIN = 'shipments';

const Logo = <svg width="315" height="42" viewBox="0 0 315 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M77.7313 39.9899C76.2535 40.4628 74.2436 40.9062 71.7018 41.32C69.1599 41.7338 67.1796 41.9407 65.7609 41.9407C60.2634 41.9407 56.3915 40.2264 54.1452 36.7978C51.958 33.3693 51.3669 28.0787 52.3718 20.926C53.3767 13.7142 55.4753 8.4236 58.6674 5.05416C61.8595 1.68472 66.2043 0 71.7018 0C73.3569 0 75.1008 0.177339 76.9333 0.532018C78.7658 0.886697 79.9776 1.18226 80.5687 1.41871C81.1599 1.65516 81.5736 1.80294 81.8101 1.86206L79.7707 8.24626C78.7067 7.71424 77.3471 7.33001 75.6919 7.09356C74.0367 6.85711 72.884 6.73888 72.2338 6.73888C68.687 6.73888 66.1156 7.92114 64.5195 10.2857C62.9235 12.5911 61.8299 16.1378 61.2388 20.926C60.5294 25.8324 60.6476 29.3792 61.5935 31.5663C62.6575 33.9309 64.8447 35.1131 68.155 35.1131H69.9284L71.4358 24.3841H67.1796L68.155 17.6452H80.8347L77.7313 39.9899Z" fill="#002654" />
        <path d="M83.9207 40.9653L89.5955 0.709356H111.32L110.256 7.62557H97.2211L95.891 16.9359H105.822L104.935 23.4087H94.9157L93.4083 34.0491H106.62L105.733 40.9653H83.9207Z" fill="#002654" />
        <path d="M128.756 35.0244C131.18 35.0244 133.071 33.8126 134.431 31.389C135.791 28.9062 136.766 25.4186 137.357 20.926C138.007 16.3743 137.978 12.8866 137.268 10.463C136.559 7.98025 135.022 6.73888 132.658 6.73888C130.352 6.73888 128.52 7.98025 127.16 10.463C125.8 12.8866 124.796 16.3743 124.145 20.926C123.495 25.4186 123.495 28.9062 124.145 31.389C124.796 33.8126 126.332 35.0244 128.756 35.0244ZM133.633 0C138.598 0 142.175 1.68472 144.362 5.05416C146.549 8.4236 147.14 13.7142 146.135 20.926C145.13 28.0787 143.061 33.3397 139.928 36.7092C136.795 40.0786 132.746 41.7633 127.781 41.7633C117.554 41.7633 113.416 34.8175 115.367 20.926C116.372 13.7142 118.441 8.4236 121.574 5.05416C124.707 1.68472 128.727 0 133.633 0Z" fill="#002654" />
        <path d="M168.814 0C171.651 0 173.749 0.266009 175.109 0.798027C176.469 1.33004 177.415 1.74383 177.947 2.0394C178.538 2.33496 178.981 2.54186 179.277 2.66009L176.35 8.77828L175.198 8.15759C172.774 6.97533 170.646 6.3842 168.814 6.3842C167.277 6.3842 165.917 6.91622 164.735 7.98025C163.671 8.98517 163.139 9.93098 163.139 10.8177C162.961 12.059 163.168 13.1231 163.759 14.0098C164.41 14.8965 165.237 15.7241 166.242 16.4925C167.247 17.261 168.341 18.0295 169.523 18.7979C170.764 19.5664 171.858 20.4531 172.804 21.458C175.168 23.7634 176.084 26.66 175.552 30.1476C175.08 33.6353 173.572 36.4432 171.03 38.5712C168.488 40.6993 165.001 41.7633 160.567 41.7633C156.961 41.7633 153.828 41.0244 151.168 39.5466C150.636 39.1919 150.193 38.9259 149.838 38.7486L152.676 32.6304C152.971 32.7486 153.356 32.9555 153.828 33.2511C154.36 33.5466 154.952 33.8126 155.602 34.0491C157.257 34.7584 158.794 35.1131 160.213 35.1131C162.814 35.1131 164.764 34.2264 166.065 32.453C166.479 31.921 166.745 31.1821 166.863 30.2363C167.04 29.2314 166.804 28.3447 166.153 27.5762C165.503 26.7486 164.676 25.9802 163.671 25.2708C162.666 24.5023 161.572 23.7339 160.39 22.9654C159.208 22.1378 158.114 21.2216 157.109 20.2166C154.804 17.9112 153.888 15.0147 154.36 11.527C154.833 7.98025 156.341 5.17239 158.883 3.10343C161.424 1.03448 164.735 0 168.814 0Z" fill="#CE1126" />
        <path d="M209.763 40.9653H201.339L203.733 24.3841H192.738L190.433 40.9653H181.92L187.595 0.709356H196.107L193.713 17.6452H204.62L206.925 0.709356H215.437L209.763 40.9653Z" fill="#CE1126" />
        <path d="M225.957 40.9653H217.444L223.119 0.709356H231.632L225.957 40.9653Z" fill="#CE1126" />
        <path d="M249.481 6.82755C249.067 6.82755 248.653 6.82755 248.24 6.82755C247.826 6.82755 247.382 6.85711 246.91 6.91622L244.781 21.5467H247.176C250.013 21.5467 251.993 20.2462 253.116 17.6452C253.53 16.6994 253.855 15.5172 254.092 14.0984C254.742 9.25118 253.205 6.82755 249.481 6.82755ZM239.55 0.709356L250.102 0.443347C255.304 0.443347 258.85 1.59605 260.742 3.90146C262.693 6.20686 263.313 9.60586 262.604 14.0984C261.954 18.8866 260.121 22.4629 257.107 24.8275C254.565 26.7782 251.136 27.7535 246.821 27.7535C246.348 27.7535 245.875 27.7535 245.402 27.7535C244.929 27.7535 244.456 27.724 243.983 27.6649L242.121 40.9653H233.875L239.55 0.709356Z" fill="#CE1126" />
        <path d="M27.2763 0.519531H48.9656L48.0582 7.53343H26.2372L27.2763 0.519531Z" fill="#002654" />
        <path d="M15.0669 16.3657H46.6276L45.7202 23.3796H14.0278L15.0669 16.3657Z" fill="#002654" />
        <path d="M1.0391 34.0304H44.0299L43.1225 41.0443H0L1.0391 34.0304Z" fill="#002654" />
        <path d="M287.179 41.0443H265.49L266.397 34.0304H288.218L287.179 41.0443Z" fill="#CE1126" />
        <path d="M313.416 7.53343H270.297L271.205 0.519531H314.455L313.416 7.53343Z" fill="#CE1126" />
        <path d="M301.013 23.3796H267.959L268.867 16.3657H302.052L301.013 23.3796Z" fill="#CE1126" />
    </svg>

const Files = [
    { key: 'cargo', fr: 'Manifest Cargo', en: 'Manifest Cargo' },
    { key: 'douane', fr: 'Manifest Douane', en: 'Manifest Customs' },
    { key: 'colis', fr: 'Manifest Colis', en: 'Manifest HU' },
    { key: 'extra', fr: 'Manifest Extra', en: 'Manifest Extra' },


]

const Incotermes = [
    { key: 'EXW', fr: 'EXW', en: 'EXW', name: 'EXW - Ex Works' },
    { key: 'FCA', fr: 'FCA', en: 'FCA', name: 'FCA - Free Carrier' },
    { key: 'CPT', fr: 'CPT', en: 'CPT', name: 'CPT - Carriage Paid To' },
    { key: 'CIP', fr: 'CIP', en: 'CIP', name: 'CIP - Carriage and Insurance Paid To' },
    { key: 'DAP', fr: 'DAP', en: 'DAP', name: 'DAP - Delivered at Place' },
    { key: 'DPU', fr: 'DPU', en: 'DPU', name: 'DPU - Delivered at Place Unloaded' },
    { key: 'DDP', fr: 'DDP', en: 'DDP', name: 'DDP - Delivered Duty Paid' },
    { key: 'FAS', fr: 'FAS', en: 'FAS', name: 'FAS - Free Alongside Ship' },
    { key: 'FOB', fr: 'FOB', en: 'FOB', name: 'FOB - Free on Board' },
    { key: 'CFR', fr: 'CFR', en: 'CFR', name: 'CFR - Cost and Freight' },
    { key: 'CIF', fr: 'CIF', en: 'CIF', name: 'CIF - Cost, Insurance and Freight' }
]

const Units = [
    { key: 'KG', fr: 'Kilogramme', en: 'Kilogram', type: 'Poids', domaine: 'Transport' },
    { key: 'TON', fr: 'Tonne', en: 'Ton', type: 'Poids', domaine: 'Transport' },
    { key: 'PAL', fr: 'Palette', en: 'Pallet', type: 'Unité logistique', domaine: 'Transport' },
    { key: 'HU', fr: 'Unité de manutention', en: 'Handling Unit', type: 'Unité logistique', domaine: 'Transport' },
    { key: 'COL', fr: 'Colis', en: 'Package', type: 'Unité logistique', domaine: 'Transport' },
    { key: 'CONT', fr: 'Conteneur', en: 'Container', type: 'Unité logistique', domaine: 'Transport' },
    { key: 'KM', fr: 'Kilomètre', en: 'Kilometer', type: 'Distance', domaine: 'Transport' },
    { key: 'FIX', fr: 'Forfait', en: 'Flat rate', type: 'Forfait', domaine: 'Transport / Service' },
    { key: 'DAY', fr: 'Jour', en: 'Day', type: 'Temps', domaine: 'Transport / Service' },
    { key: 'HDAY', fr: 'Jour-homme', en: 'Man-day', type: 'Temps', domaine: 'Service' },
    { key: 'HOUR', fr: 'Heure', en: 'Hour', type: 'Temps', domaine: 'Service' },
    { key: 'TASK', fr: 'Tâche', en: 'Task', type: 'Unité métier', domaine: 'Service' },
    { key: 'PRJ', fr: 'Projet', en: 'Project', type: 'Forfait', domaine: 'Service' },
    { key: 'MAINT', fr: 'Maintenance', en: 'Maintenance', type: 'Service récurrent', domaine: 'Service' },
    { key: 'DEV', fr: 'Développement logiciel', en: 'Software development', type: 'Prestation', domaine: 'Service' },
    { key: 'CONS', fr: 'Conseil', en: 'Consulting', type: 'Prestation', domaine: 'Service' },
    { key: 'STUDY', fr: 'Étude', en: 'Study', type: 'Prestation', domaine: 'Service' },
    { key: 'PCT', fr: 'Pourcentage', en: 'Percentage', type: 'Taux', domaine: 'Service' },
];

const TaxRates = [
    { key: 'tax_0', rate: 0, fr: '0%', en: '0%' },
    { key: 'tax_2_1', rate: 2.1, fr: '2.1%', en: '2.1%' },
    { key: 'tax_5_5', rate: 5.5, fr: '5.5%', en: '5.5%' },
    { key: 'tax_10', rate: 10, fr: '10%', en: '10%' },
    { key: 'tax_20', rate: 20, fr: '20%', en: '20%' },
];

const Currencies = [
    { key: 'EUR', fr: 'EUR', en: 'EUR', name: 'EUR - Euro' },
    { key: 'USD', fr: 'USD', en: 'USD', name: 'USD - Dollar américain / US Dollar' },
    { key: 'GBP', fr: 'GBP', en: 'GBP', name: 'GBP - Livre sterling / British Pound' },
    { key: 'CHF', fr: 'CHF', en: 'CHF', name: 'CHF - Franc suisse / Swiss Franc' },
    { key: 'JPY', fr: 'JPY', en: 'JPY', name: 'JPY - Yen japonais / Japanese Yen' },
    { key: 'CNY', fr: 'CNY', en: 'CNY', name: 'CNY - Yuan chinois / Chinese Yuan' },
    { key: 'CAD', fr: 'CAD', en: 'CAD', name: 'CAD - Dollar canadien / Canadian Dollar' },
    { key: 'AUD', fr: 'AUD', en: 'AUD', name: 'AUD - Dollar australien / Australian Dollar' },
    { key: 'AED', fr: 'AED', en: 'AED', name: 'AED - Dirham des Émirats / UAE Dirham' },
    { key: 'SAR', fr: 'SAR', en: 'SAR', name: 'SAR - Riyal saoudien / Saudi Riyal' }
];

const ShipmentDirections = [
    { key: 'import', fr: 'Import', en: 'Import' },
    { key: 'export', fr: 'Export', en: 'Export' },
    { key: 'domestic', fr: 'Domestique', en: 'Domestic' },
    { key: 'intraEu', fr: 'Intra-UE', en: 'Intra-EU' },
];


const ShipmentStatus = [
    { key: 'inProgress', fr: 'En cours', en: 'In progress' },
    { key: 'blocked', fr: 'Bloqué', en: 'Blocked' },
    { key: 'delivered', fr: 'Livré', en: 'Delivered' },
];


const Linked = [
    { key: 'linked', fr: 'Groupé', en: 'Linked', description: 'Indicates if the shipment is linked to a groupage.' },
    { key: 'notLinked', fr: 'Non groupé', en: 'Not linked', description: 'Indicates if the shipment is not linked to any groupage.' },
    { key: 'all', fr: 'Tous', en: 'All', description: 'Indicates all shipments, regardless of their linked status.' }
];


const TransportMode = [
    { key: 'road', fr: 'Routier', en: 'Road', volumeWeightRatio: 250 },  // среднее между 3 и 4
    { key: 'air', fr: 'Aérien', en: 'Air', volumeWeightRatio: 167 },
    { key: 'maritime', fr: 'Maritime', en: 'Maritime', volumeWeightRatio: 1000 },
    { key: 'rail', fr: 'Ferroviaire', en: 'Rail', volumeWeightRatio: 333 },
    { key: 'inlandwater', fr: 'Fluvial', en: 'Inland Waterway', volumeWeightRatio: 1000 },
    { key: 'multimodal', fr: 'Multimodal', en: 'Multimodal', volumeWeightRatio: 333 }, // null
    { key: 'intermodal', fr: 'Intermodal', en: 'Intermodal', volumeWeightRatio: 333 }, // null
    { key: 'express', fr: 'Express', en: 'Express', volumeWeightRatio: 200 }
];

const EuropeanCountryCodes = [
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
    'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
    'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'
];


const VatCountries = [
    { code: "AL", fr: "Albanie", en: "Albania", vatRate: 20 },
    { code: "DE", fr: "Allemagne", en: "Germany", vatRate: 19 },
    { code: "SA", fr: "Arabie saoudite", en: "Saudi Arabia", vatRate: 15 },
    { code: "AM", fr: "Arménie", en: "Armenia", vatRate: 20 },
    { code: "AT", fr: "Autriche", en: "Austria", vatRate: 20 },
    { code: "AZ", fr: "Azerbaïdjan", en: "Azerbaijan", vatRate: 18 },
    { code: "BE", fr: "Belgique", en: "Belgium", vatRate: 21 },
    { code: "BG", fr: "Bulgarie", en: "Bulgaria", vatRate: 20 },
    { code: "BY", fr: "Biélorussie", en: "Belarus", vatRate: 20 },
    { code: "CA", fr: "Canada", en: "Canada", vatRate: 5 },
    { code: "CH", fr: "Suisse", en: "Switzerland", vatRate: 8.1 },
    { code: "CY", fr: "Chypre", en: "Cyprus", vatRate: 19 },
    { code: "CZ", fr: "Tchéquie", en: "Czech Republic", vatRate: 21 },
    { code: "DK", fr: "Danemark", en: "Denmark", vatRate: 25 },
    { code: "EE", fr: "Estonie", en: "Estonia", vatRate: 22 },
    { code: "EG", fr: "Égypte", en: "Egypt", vatRate: 14 },
    { code: "ES", fr: "Espagne", en: "Spain", vatRate: 21 },
    { code: "FI", fr: "Finlande", en: "Finland", vatRate: 24 },
    { code: "FR", fr: "France", en: "France", vatRate: 20 },
    { code: "GE", fr: "Géorgie", en: "Georgia", vatRate: 18 },
    { code: "GR", fr: "Grèce", en: "Greece", vatRate: 24 },
    { code: "HR", fr: "Croatie", en: "Croatia", vatRate: 25 },
    { code: "HU", fr: "Hongrie", en: "Hungary", vatRate: 27 },
    { code: "IE", fr: "Irlande", en: "Ireland", vatRate: 23 },
    { code: "IL", fr: "Israël", en: "Israel", vatRate: 17 },
    { code: "IS", fr: "Islande", en: "Iceland", vatRate: 24 },
    { code: "IT", fr: "Italie", en: "Italy", vatRate: 22 },
    { code: "JO", fr: "Jordanie", en: "Jordan", vatRate: 16 },
    { code: "KZ", fr: "Kazakhstan", en: "Kazakhstan", vatRate: 12 },
    { code: "LB", fr: "Liban", en: "Lebanon", vatRate: 11 },
    { code: "LT", fr: "Lituanie", en: "Lithuania", vatRate: 21 },
    { code: "LU", fr: "Luxembourg", en: "Luxembourg", vatRate: 16 },
    { code: "LV", fr: "Lettonie", en: "Latvia", vatRate: 21 },
    { code: "MC", fr: "Monaco", en: "Monaco", vatRate: 20 },
    { code: "MD", fr: "Moldavie", en: "Moldova", vatRate: 20 },
    { code: "ME", fr: "Monténégro", en: "Montenegro", vatRate: 21 },
    { code: "MK", fr: "Macédoine du Nord", en: "North Macedonia", vatRate: 18 },
    { code: "MT", fr: "Malte", en: "Malta", vatRate: 18 },
    { code: "NL", fr: "Pays-Bas", en: "Netherlands", vatRate: 21 },
    { code: "NO", fr: "Norvège", en: "Norway", vatRate: 25 },
    { code: "PL", fr: "Pologne", en: "Poland", vatRate: 23 },
    { code: "PT", fr: "Portugal", en: "Portugal", vatRate: 23 },
    { code: "RO", fr: "Roumanie", en: "Romania", vatRate: 19 },
    { code: "RS", fr: "Serbie", en: "Serbia", vatRate: 20 },
    { code: "RU", fr: "Russie", en: "Russia", vatRate: 20 },
    { code: "SE", fr: "Suède", en: "Sweden", vatRate: 25 },
    { code: "SI", fr: "Slovénie", en: "Slovenia", vatRate: 22 },
    { code: "SK", fr: "Slovaquie", en: "Slovakia", vatRate: 20 },
    { code: "SY", fr: "Syrie", en: "Syria", vatRate: 0 },
    { code: "TN", fr: "Tunisie", en: "Tunisia", vatRate: 19 },
    { code: "TR", fr: "Turquie", en: "Turkey", vatRate: 20 },
    { code: "UA", fr: "Ukraine", en: "Ukraine", vatRate: 20 },
    { code: "US", fr: "États-Unis", en: "United States", vatRate: 0 },
    { code: "UZ", fr: "Ouzbékistan", en: "Uzbekistan", vatRate: 15 },
    { code: "XK", fr: "Kosovo", en: "Kosovo", vatRate: 18 },
    { code: "GH", fr: "Ghana", en: "Ghana", vatRate: 0 },
    { code: "HK", fr: "Hong Kong", en: "Hong Kong", vatRate: 0 },
    { code: "KG", fr: "Kirghizistan", en: "Kyrgyzstan", vatRate: 12 },
    { code: "GB", fr: "Royaume-Uni", en: "United Kingdom", vatRate: 20 },
    { code: "AU", fr: "Australie", en: "Australia", vatRate: 10 },
    { code: "VG", fr: "Îles Vierges britanniques", en: "British Virgin Islands", vatRate: 0 },
    { code: "PA", fr: "Panama", en: "Panama", vatRate: 7 },
    { code: "MN", fr: "Mongolie", en: "Mongolia", vatRate: 10 },
    { code: "SG", fr: "Singapour", en: "Singapore", vatRate: 9 },
    { code: "NC", fr: "Nouvelle-Calédonie", en: "New Caledonia", vatRate: 0 },
    { code: "SM", fr: "Saint-Marin", en: "San Marino", vatRate: 0 },
    { code: "AI", fr: "Anguilla", en: "Anguilla", vatRate: 0 },
    { code: "EC", fr: "Équateur", en: "Ecuador", vatRate: 12 },
    { code: "IN", fr: "Inde", en: "India", vatRate: 18 },
    { code: "CN", fr: "Chine", en: "China", vatRate: 13 },
    { code: "JP", fr: "Japon", en: "Japan", vatRate: 10 },
    { code: "BR", fr: "Brésil", en: "Brazil", vatRate: 17 },
    { code: "AR", fr: "Argentine", en: "Argentina", vatRate: 21 },
    { code: "MX", fr: "Mexique", en: "Mexico", vatRate: 16 },
    { code: "ZA", fr: "Afrique du Sud", en: "South Africa", vatRate: 15 },
    { code: "KR", fr: "Corée du Sud", en: "South Korea", vatRate: 10 },
    { code: "NZ", fr: "Nouvelle-Zélande", en: "New Zealand", vatRate: 15 },
    { code: "AE", fr: "Émirats arabes unis", en: "United Arab Emirates", "vatRate": 5 },
    { code: "TH", fr: "Thaïlande", en: "Thailand", "vatRate": 7 },
    { code: "TW", fr: "Taïwan", en: "Taiwan", "vatRate": 5 },
    { code: "PH", fr: "Philippines", en: "Philippines", "vatRate": 12 },
    { code: "MY", fr: "Malaisie", en: "Malaysia", "vatRate": 6 },
    { code: "ID", fr: "Indonésie", en: "Indonesia", "vatRate": 11 },
    { code: "BH", fr: "Bahreïn", en: "Bahrain", "vatRate": 10 },
    { code: "CL", fr: "Chili", en: "Chile", "vatRate": 19 },
    { code: "CM", fr: "Cameroun", en: "Cameroon", "vatRate": 19.25 }
];

const ALPHA_NUMERIC_DASH_REGEX = /^[a-zA-Z0-9-]+$/;

const DefaultServiceList = ["300", "354", "356", "315"];


const PaymentTerms = [
    { key: 'immediate', fr: 'Comptant', en: 'Immediate', days: 0 },
    { key: 'net7', fr: '7 jours', en: '7 days', days: 7 },
    { key: 'net15', fr: '15 jours', en: '15 days', days: 15 },
    { key: 'net30', fr: '30 jours', en: '30 days', days: 30 },
    { key: 'net45', fr: '45 jours', en: '45 days', days: 45 },
    { key: 'net60', fr: '60 jours', en: '60 days', days: 60 },
    { key: 'net90', fr: '90 jours', en: '90 days', days: 90 },
    { key: 'endOfMonth', fr: 'Fin de mois', en: 'End of month', days: null },
    { key: 'endOfMonth30', fr: 'Fin de mois + 30 jours', en: 'End of month + 30 days', days: null },
    { key: 'endOfMonth45', fr: 'Fin de mois + 45 jours', en: 'End of month + 45 days', days: null },
    { key: 'endOfMonth60', fr: 'Fin de mois + 60 jours', en: 'End of month + 60 days', days: null }
];

const DefaultPaymentTerm = PaymentTerms.find(term => term.key === 'net15'); // Default to 'net30'

const PaymentMethods = [    
    { key: 'bankTransfer', fr: 'Virement bancaire', en: 'Bank Transfer' },
    { key: 'creditCard', fr: 'Carte de crédit', en: 'Credit Card' },
    { key: 'cash', fr: 'Espèces', en: 'Cash' },
    // { key: 'check', fr: 'Chèque', en: 'Check' },
    // { key: 'paypal', fr: 'PayPal', en: 'PayPal' },
    { key: 'other', fr: 'Autre', en: 'Other' }
];


export {
    PAGE_AFTER_LOGIN,
    Files,
    ALPHA_NUMERIC_DASH_REGEX,
    DefaultServiceList,
    Incotermes,
    ShipmentDirections,
    ShipmentStatus,
    TransportMode,
    Currencies,
    Units,
    TaxRates,
    EuropeanCountryCodes,
    VatCountries,
    Linked,
    PaymentTerms,
    DefaultPaymentTerm,
    PaymentMethods
}
